import { render, staticRenderFns } from "./contentLectureImage.vue?vue&type=template&id=502a1eec&"
import script from "./contentLectureImage.vue?vue&type=script&lang=js&"
export * from "./contentLectureImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports